import React from 'react';
import { useParams } from 'react-router-dom';
import Nav from '../components/nav/Nav';
import ProductDetail from '../components/product-list/ProductDetail'
import Footer from '../components/footer/Footer'

function ProductDetailPage() {
    const { category_slug, product_slug } = useParams();

    return (
        <div className='page-container'>
            <Nav />
            <div className='page-content'>
            {/* Render only the ProductDetail component */}
            <ProductDetail category_slug={category_slug} product_slug={product_slug} />
            </div>
        <Footer />
        </div>
    );
}

export default ProductDetailPage;
